export const ROUTE_LOGIN = 'login';
export const ROUTE_ADMIN = 'admin';
export const ROUTE_ACCESS_DENIED = 'access-denied';
export const ROUTE_OVERVIEW = `overview`;
export const ROUTE_START = 'start';
export const ROUTE_USER = 'user';
export const ROUTE_USER_DETAILS = `${ROUTE_OVERVIEW}/details/:email`;
export const ROUTE_TENANT = 'tenant';
export const ROUTE_TENANT_DETAILS = `${ROUTE_OVERVIEW}/:name`;
export const ROUTE_CONFIGURATION = 'configurations';
export const ROUTE_DEVICE = 'device';
export const ROUTE_DEVICE_ATTRIBUTES = `${ROUTE_OVERVIEW}/attributes/:deviceId`;
export const ROUTE_DEVICE_EVENTS = `${ROUTE_OVERVIEW}/events/:deviceId`;
export const ROUTE_FAQ = `FAQ`;
export const PATH_USER_OVERVIEW = `/${ROUTE_ADMIN}/${ROUTE_USER}/${ROUTE_OVERVIEW}`;
export const PATH_TENANT_OVERVIEW = `/${ROUTE_ADMIN}/${ROUTE_TENANT}/${ROUTE_OVERVIEW}`;
export const PATH_DEVICE_OVERVIEW = `/${ROUTE_ADMIN}/${ROUTE_DEVICE}/${ROUTE_OVERVIEW}`;
export const PATH_CONFIGURATION = `/${ROUTE_ADMIN}/${ROUTE_CONFIGURATION}/${ROUTE_OVERVIEW}`;
export const ROUTE_SMOKE_CONFIGURATION = 'smoke';
export const ROUTE_DAMAGE_CONFIGURATION = 'damage';
export const PATH_SMOKE_CONFIGURATION_OVERVIEW = `${PATH_CONFIGURATION}/${ROUTE_SMOKE_CONFIGURATION}`;
export const PATH_DAMAGE_CONFIGURATION_OVERVIEW = `${PATH_CONFIGURATION}/${ROUTE_DAMAGE_CONFIGURATION}`;
export const PATH_FAQ = `/${ROUTE_ADMIN}/${ROUTE_FAQ}`;
